import resizeDirective from "@plugins/directives/resize.js";
import shortcutDirective from "@plugins/directives/shortcut.js";
import tooltipDirective from "@plugins/directives/tooltip";
import notificationHub from "@plugins/notificationHub";
import { vOnClickOutside } from "@vueuse/components";
import { BootstrapVue } from "bootstrap-vue";
import Vue, { configureCompat, createApp, reactive } from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import vue_axios from "./plugins/vue-axios";
import "./registerServiceWorker";
import router from "./router/index";
import store from "./store";
import VueDOMPurifyHTML from "vue-dompurify-html";
import SafeDirectivesPlugin from "@/plugins/safeDirectivesPlugin";
import emitter from "tiny-emitter/instance";

export const cspState = reactive({
  lastViolation: null as { blockedURI: string; effectiveDirective: string } | null
});

window.addEventListener("securitypolicyviolation", (e) => {
  cspState.lastViolation = {
    blockedURI: e.blockedURI,
    effectiveDirective: e.effectiveDirective
  };
  emitter.emit("csp-error", cspState);
});

const app = createApp(App);

app.use(router);
app.use(store);
app.use(i18n);
app.use(vue_axios);
app.use(notificationHub);
app.use(VueDOMPurifyHTML);
app.use(SafeDirectivesPlugin);

app.directive("resize", resizeDirective);
app.directive("shortcut", shortcutDirective);
app.directive("tooltip", tooltipDirective);
app.directive("on-click-outside", vOnClickOutside);

Vue.use(BootstrapVue);

app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("ll-desktopdesigner");

app.mount("#app");

configureCompat({
  ATTR_FALSE_VALUE: "suppress-warning",
  COMPONENT_FUNCTIONAL: "suppress-warning",
  COMPONENT_V_MODEL: "suppress-warning",
  CUSTOM_DIR: "suppress-warning",
  GLOBAL_EXTEND: "suppress-warning",
  GLOBAL_MOUNT: "suppress-warning",
  GLOBAL_PROTOTYPE: "suppress-warning",
  INSTANCE_ATTRS_CLASS_STYLE: "suppress-warning",
  INSTANCE_DESTROY: "suppress-warning",
  INSTANCE_EVENT_EMITTER: "suppress-warning",
  INSTANCE_LISTENERS: "suppress-warning",
  INSTANCE_SCOPED_SLOTS: "suppress-warning",
  OPTIONS_BEFORE_DESTROY: "suppress-warning",
  OPTIONS_DATA_MERGE: "suppress-warning",
  OPTIONS_DESTROYED: "suppress-warning",
  RENDER_FUNCTION: "suppress-warning",
  WATCH_ARRAY: "suppress-warning"
});
export default app;
